export default {
  background: "#f2f4f7",
  white: "#fff",
  skyBlue: "#70bbfd",
  headerTextColor: "#646777"
};
// #1c74bc
// #231f20